import { UserService } from './user.service';
import { SharedService } from './shared.service';
import { AppComponent } from '../../dbm.data.store.component';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class UserAgreementAcceptGaurd implements CanActivate {
  constructor(private sharedService: SharedService, private user: UserService) {

  }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return true;
    }
}